// extracted by mini-css-extract-plugin
module.exports = {"title":"basics_title__xOHBx","titleImg":"basics_titleImg__3AhWp","tipsTextLine":"basics_tipsTextLine__16hvY","inputIcon":"basics_inputIcon__2X2iB"};